import React from 'react';
import '../style/userLayout.css';
import UserContentRouter from '../routers/userContentRouter';

const LayoutContent = (props) => {
    return (
        <div className="row user-layout-content">
            <UserContentRouter {...props} />
        </div>
    )
};

export default LayoutContent;